import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import ArrowButton from "/src/components/ArrowButton"
import ArticleList from "/src/components/ArticleList"
import BottomContact from "/src/components/BottomContact"
import Layout from "/src/components/Layout"
import Seo from "/src/components/Seo"
import ArticleMedia from "/src/components/ArticleMedia"
import json from "/src/siteData.json"
import { formatDate } from "/src/utils/formatDate"
import * as style from "./style.module.css"

const Page = ({ location, pageContext }) => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "picture/blog_sample.jpg" }) {
        publicURL
      }
    }
  `)

  return (
    <Layout>
      <div className={style.container}>
        <div className="content">
          <article className="blog-post" itemScope>
            <div className={style.top_visual}>
              <h1 itemProp="headline">{pageContext.title}</h1>
              <time dateTime={pageContext.createTime}>
                {formatDate(pageContext.createTime)}
              </time>
              <div className={style.top_visual_media}>
                {pageContext.media ? (
                  <ArticleMedia media={pageContext.media} />
                ) : (
                  <ArticleMedia media={{ url: data.file.publicURL, type: 1 }} />
                )}
              </div>
            </div>
            <div className={style.body_contents}>
              <section
                dangerouslySetInnerHTML={{ __html: pageContext.content }}
                itemProp="articleBody"
              />
            </div>
          </article>
        </div>
        <div className={style.arrow_button}>
          <ArrowButton link={`/${pageContext.linkPrefix}1`} text="記事一覧へ" />
        </div>
        <div className={style.blog}>
          <div className={style.blog_title}>
            <h2>NEW ARTICLES</h2>
            <small>新着記事</small>
          </div>
          <div className={style.blog_container}>
            <ArticleList
              articles={json.articles.content.slice(0, 3)}
              location={location}
            />
          </div>
        </div>
      </div>
      <BottomContact />
    </Layout>
  )
}

export default Page

export const Head = ({ pageContext }) => {
  return <Seo pageContext={pageContext} />
}
